var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { InputMessage } from '../../atoms/InputMessage';
import { SegmentedControlStyle } from './SegmentedControlStyle';
import { randomString } from '../../utils/randomString';
export var SegmentedControl = function (_a) {
    var className = _a.className, onClick = _a.onClick, preFilledValue = _a.preFilledValue, options = _a.options, error = _a.error, _b = _a.dataCy, dataCy = _b === void 0 ? 'segmented-control' : _b, _c = _a.tabFocusTrap, tabFocusTrap = _c === void 0 ? 0 : _c, ariaLiveOnFocus = _a.ariaLiveOnFocus, _d = _a.name, name = _d === void 0 ? 'radio group' : _d;
    var itemsRef = useRef([]);
    var _e = useState(), selected = _e[0], setSelected = _e[1];
    var _f = useState(''), controlError = _f[0], setControlError = _f[1];
    var _g = useState(0), errorWidth = _g[0], setErrorWidth = _g[1];
    var _h = useState(-1), focused = _h[0], setFocused = _h[1];
    var _j = useState([]), labelWidths = _j[0], setLabelWidths = _j[1];
    var errorIdRef = useRef(randomString());
    useEffect(function () {
        var index = options.findIndex(function (_a) {
            var value = _a.value;
            return value === preFilledValue;
        });
        setSelected(index >= 0 ? index : undefined);
    }, [preFilledValue]);
    useEffect(function () {
        setControlError(error || '');
    }, [error]);
    var handleSelected = function (value, index) {
        setControlError('');
        var isSelected = selected === index;
        if (isSelected) {
            return;
        }
        onClick(value);
        setSelected(index);
    };
    useLayoutEffect(function () {
        var totalWidth = options === null || options === void 0 ? void 0 : options.reduce(function (total, _cur, i) { var _a; return (((_a = itemsRef.current[i]) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0) + total; }, 0);
        setErrorWidth(totalWidth);
        var lengthArray = options === null || options === void 0 ? void 0 : options.map(function (value, i) { var _a; return ((_a = itemsRef.current[i]) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0; });
        setLabelWidths(lengthArray);
    }, []);
    return (_jsx(_Fragment, { children: _jsxs(SegmentedControlStyle, __assign({ className: className, error: error, errorWidth: errorWidth, labelWidths: labelWidths, focused: focused }, { children: [_jsx("div", __assign({ radioGroup: name, className: "segmented-control ".concat(error && controlError && 'is-error') }, { children: options.map(function (option, i) {
                        var optionId = randomString();
                        var controlString = "".concat(dataCy, "-").concat(option.label.replace(' ', '-'));
                        return (_jsxs("div", __assign({ className: "control-wrapper ".concat(i === selected ? 'active' : ''), "data-cy": controlString }, { children: [_jsx("div", __assign({ id: optionId, ref: function (el) { return (itemsRef.current[i] = el); }, className: "control-button button-".concat(i), onClick: function () { return handleSelected(option.value, i); } }, { children: option.label })), _jsx("input", { id: "input-".concat(controlString), className: "hidden-input", type: "radio", name: name, checked: i === selected, onBlur: function () { return setFocused(-1); }, onFocus: function () {
                                        setFocused(i);
                                    }, onClick: function () { return handleSelected(option.value, i); }, tabIndex: tabFocusTrap || (i === selected || (!selected && i === 0) ? 0 : -1), "aria-labelledby": optionId, "aria-checked": i === selected })] }), i));
                    }) })), error && controlError && (_jsx("div", __assign({ className: "error-container" }, { children: _jsx(InputMessage, { errorId: errorIdRef.current, className: "error-message", message: error, ariaLive: ariaLiveOnFocus ? focused >= 0 : true }) })))] })) }));
};
